import React, {useState} from "react";

const AppContext = React.createContext({
    isLoggedIn: null,
    setLoggedIn: () => {},
    doLogout: () => {}
})

export const AppContextProvider = (props) => {
    const [isLoggedIn, setIsLoggedIn] = useState(
        sessionStorage.getItem('token')
    );

    const setLoggedIn = (val) => {
        setIsLoggedIn(val)
    }
    const doLogout = () => {
        sessionStorage.removeItem('tokens');
        sessionStorage.clear();
        setIsLoggedIn(false);
    }

    return(
        <AppContext.Provider value={{
            isLoggedIn,
            setLoggedIn,
            doLogout
        }}>
            {props.children}
        </AppContext.Provider>
    )
}

export default AppContext;
